import VueRouter from "vue-router";
import { getToken, getTokenNew, setTokenNew, setIsBudgetHealthProjectAtivitySystemPermissionSession, getIsBudgetHealthProjectAtivitySystemPermissionSession } from "@/utils/userStorage";
import store from "@/store/index";
import { MessageBox } from "element-ui";

export function createTokenCheckGuard(router: VueRouter): void {
  router.beforeEach(async (to, from, next) => {
    const isNew = (to as any).meta.isNew;
    if (isNew) {
      store.dispatch("UPDATE_VERSION", "v2");
    } else {
      store.dispatch("UPDATE_VERSION", "v1");
    }
    if (store.state.isBudgetSystem === null) {
      store.commit("SET_isBudgetSystem", location.href.includes("budget-business"));
    }
    if (store.state.isBudgetHealthProjectAtivitySystemPermission === null) {
      // 2026年6月6日10:43:46 有预算系统健康项目活动进去 后期还预算检验;

      // 如果是相当于现在有三种场景
      // 1 预算系统进入活动添加页面 无isBudgetHealthProjectAtivitySystemPermission
      // 2 健康活动项目 的活动组管理中的模版编辑进入 (带有/budgetActivity 子路由).
      //    (此时有isBudgetHealthProjectAtivitySystemPermission 同时也有comtyId 设为 固定值common_template)
      //   具体参考固定值common_template D:\gitlab_2025\m_saas_business_admin\src\modules\budgetActivity\router.vue
      // 3 健康活动项目  的活动落地管理(以及外部审核)进入 相当于做了一套额外权限的社区落地页
      //   (此时有isBudgetHealthProjectAtivitySystemPermission, 但无comtyId,在此处清除缓存中的comtyId)
      // console.log("isBudgetHealthProjectAtivitySystemPermission", location.href.includes("isBudgetHealthProjectAtivitySystemPermission"));

      const isBudgetHealthProjectAtivitySystemPermission = to.query.isBudgetHealthProjectAtivitySystemPermission || getIsBudgetHealthProjectAtivitySystemPermissionSession();
      if (isBudgetHealthProjectAtivitySystemPermission) {
        setIsBudgetHealthProjectAtivitySystemPermissionSession(isBudgetHealthProjectAtivitySystemPermission);
        store.commit("SET_COMTYIDNEW", "");
      }
      store.commit("SET_isBudgetHealthProjectAtivitySystemPermission", !!isBudgetHealthProjectAtivitySystemPermission);
    }

    if (!store.state.searchItem_Inited) {
      await store.dispatch("GET_searchItem");
    }

    if ((to as any).meta.needLogin) {
      let token = isNew ? getTokenNew() : getToken();
      const urlToken = new URLSearchParams(location.search).get("token");
      if (urlToken) {
        // console.log("tokenCheckGuard.ts 从路由取token，app的新建社区用到");
        token = urlToken;
      }
      if (!store.state.isBudgetHealthProjectAtivitySystemPermission && store.state.isBudgetSystem && !(to as any).meta.isBudgetSystemWhiteList) {
        MessageBox.alert("暂无访问权限", "提示", { type: "warning" });
        next(false);

        return false;
      }
      if (token) {
        if (store.state.isBudgetHealthProjectAtivitySystemPermission) {
          // 2026年6月6日10:38:11 由预算系统健康项目活动管理进入 后期改造登录
          //
          console.log("tokenCheckGuard.ts 由预算系统健康项目活动管理进入 后期改造登录");
          setTokenNew(token);
          if (!store.state.permissionListNew) {
            // console.log("tokenCheckGuard.ts 由预算系统健康项目活动管理进入 后期改造登录，获取权限列表");

            await store.dispatch("GET_BUDGET_PERMISSIONLISTNEW");
          }
        } else if (isNew) {
          if (store.state.comtyIdNew && store.state.comtyIdNew !== "undefined" && store.state.comtyIdNew !== "common_template") {
            if (!(store.state.comtyInfoNew && store.state.comtyInfoNew.communityId)) {
              try {
                console.log(store);
                await store.dispatch("UPDATE_COMTYINFONEW", store.state.comtyIdNew);
              } catch (error) {
                console.log(error);
              }
            }
            const ignorePermission = !!to.meta?.ignorePermission;
            if (!ignorePermission) {
              if (store.state.isEverSetStateGeneService === 0) {
                await store.dispatch("UPDATE_isEverSetStateGeneService");
              }
              if (!store.state.permissionListNew) {
                await store.dispatch("GET_PERMISSIONLISTNEW");
              }
              store.dispatch("UPDATE_MESSAGENUMBERNEW", store.state.comtyIdNew);
              store.dispatch("UPDATE_TABNUM", store.state.comtyIdNew);
            }
          }
          next();
          return true;
        } else {
          if (store.state.bId && !(store.state.orgInfo && store.state.orgInfo.id)) {
            //2022年2月22日12:44:32 更新机构接口
            await store.dispatch("GET_ORGINFO");
          }
          if (!(store.state.userInfo && store.state.userInfo.id)) {
            // 2022年2月22日12:44:00  更新用户接口
            await store.dispatch("UPDATE_USERINFO", token);
          }
          if (store.state.comtyId && store.state.comtyId !== "undefined") {
            if (!(store.state.comtyInfo && store.state.comtyInfo.communityId)) {
              try {
                console.log(store);
                await store.dispatch("UPDATE_COMTYINFO", store.state.comtyId);
              } catch (error) {
                console.log(error);
              }
            }
            if (!store.state.permissionList) {
              await store.dispatch("GET_PERMISSIONLIST");
            }
            if (!(store.state.comtyConfig && store.state.comtyConfig.settledAudit)) {
              store.dispatch("UPDATE_COMTYCONFIG", store.state.comtyId);
            }
            if (store.state.messageNumber == -1) {
              store.dispatch("UPDATE_MESSAGENUMBER", store.state.comtyId);
            }
          }
          // if (to.name) {
          //   store.commit("SET_CurrentRouteName", to.name);
          //   await store.dispatch("GET_PagePermissionList");
          // }
          next();
          return true;
        }
      } else {
        if (isNew) {
          if (window.location.pathname != "/newCommunity/login") {
            window.location.replace("/newCommunity/login");
          }
          return false;
        } else {
          if (window.location.pathname != "/login") {
            window.location.replace("/login");
          }
          return false;
        }
      }
    }
    next();
    return true;
  });
}
